import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import ReportingGroupDto from "../classes/dtos/reportinggroupmodule/ReportingGroupDto";
import ReportingGroupPathDto from "../classes/dtos/reportinggroupmodule/ReportingGroupPathDto";

const ReportingGroupApi = {

    GetReportingGroupsAsync: async function (): Promise<ProcessingResult<ReportingGroupDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/GetReportingGroups", {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(
                data.reportingGroups.map((e: any) =>
                    new ReportingGroupDto
                        (
                            e.reportingGroupId,
                            e.name,
                            e.isDefault,
                            e.reportingGroupPaths.map((f: any) =>
                                new ReportingGroupPathDto(f.reportingGroupPathId, f.pathId, f.pathName)
                            ),
                            e.customerApiCredentialIds
                        )
                )
            );
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateReportingGroupAsync: async function (name: string, customerApiCredentialIds: number[]): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/CreateReportingGroup", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name,
                'customerApiCredentialIds': customerApiCredentialIds
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateReportingGroupAsync: async function (reportingGroupId: number, name: string, customerApiCredentialIds: number[]): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/UpdateReportingGroup", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'reportingGroupId': reportingGroupId,
                'name': name,
                'customerApiCredentialIds': customerApiCredentialIds
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteReportingGroupAsync: async function (reportingGroupId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/DeleteReportingGroup?id=" + reportingGroupId, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateReportingGroupPathAsync: async function (reportingGroupId: number, pathId: number): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/CreateReportingGroupPath", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'reportingGroupId': reportingGroupId,
                'pathId': pathId
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteReportingGroupPathAsync: async function (reportingGroupPathId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/ReportingGroup/DeleteReportingGroupPath?id=" + reportingGroupPathId, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default ReportingGroupApi;
